import {
  Box,
  Chip,
  LinearProgress,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React, { ReactElement } from "react";
import { LLMMaskResponse } from "../../../../types/llm";
import Highlighter from "react-highlight-words";

interface ResultsProps {
  results: LLMMaskResponse | undefined;
}

const Results = (props: ResultsProps): ReactElement => {
  const { results } = props;

  if (!results || !results.candidates || results.candidates.length === 0) {
    return <></>;
  }

  return (
    <Paper
      elevation={2}
      sx={{
        padding: 3,
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Stack spacing={2}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Predictions
        </Typography>
        {results.candidates.map((result, index) => {
          const scorePercent = Math.round(result.score * 100);

          return (
            <Box
              key={"result-" + index}
              sx={{
                paddingBottom: 2,
                borderBottom:
                  index === results.candidates.length - 1 ? "none" : "1px solid",
                borderColor: "divider",
              }}
            >
              <Stack spacing={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Chip
                    label={result.tokenStr.trim() || result.tokenStr}
                    color={index === 0 ? "primary" : "default"}
                    variant={index === 0 ? "filled" : "outlined"}
                  />
                  <Typography variant="body2" sx={{ fontWeight: 700 }}>
                    {scorePercent}%
                  </Typography>
                </Stack>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  <Highlighter
                    searchWords={result.tokenStr ? [result.tokenStr] : []}
                    autoEscape={true}
                    textToHighlight={result.sequence}
                  />
                </Typography>
                <LinearProgress
                  variant="determinate"
                  value={scorePercent}
                  sx={{ height: 8, borderRadius: 1 }}
                />
              </Stack>
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
};

export default Results;
